import AppImage from "@/components/AppImage";
import {useEffect, useRef, useState} from "react";
import {APIGetHomeSectionLast} from "@/api";
import {useSelector} from "react-redux";
import {useRouter} from "next/router";
import gaTracker from "@/ga";
import useLanguage from "@/hooks/useLanguage";
import Image from "next/image";
import Skeleton from "@/components/Skeleton";
import {getProductImageV2} from "@/utils/utils";


const HotProductWrap = () =>{
  const [productList, setProductList] = useState([]);
  const userInfo = useSelector(state => state.home.userInfo.userInfo);
  const router = useRouter();
  const scrollRef = useRef(null);
  const [hotSaleId, setHotSaleId] = useState(1);
  const [hotSaleInfo, setHotSaleInfo] = useState();
  const [loading, setLoading] = useState(true);
  const {t} = useLanguage();
  // 向左滚动
  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -400, behavior: 'smooth' });
  };

// 向右滚动
  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 400, behavior: 'smooth' });
  };


  useEffect(()=>{
    APIGetHomeSectionLast().then(res => {
      if (res?.data?.list){
        setHotSaleInfo(res?.data?.list);
        setHotSaleId(res?.data?.list?.id);
      }
      let list = res?.data?.list?.products ?? [];
      if (list.length > 10){
        list = list.slice(0, 10);
      }
      setProductList(list);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  if (loading) return <Skeleton className={"w-[360px] h-[320px] shrink-0 relative"}></Skeleton>;
  if (!productList || productList?.length <= 0) return null;
  return <div>
    {
      productList && productList?.length > 0 ?  <div className={"shrink-0 relative rounded-xl card_box_shadow"}>
        <Image width={360} height={320} className={"!w-[360px] h-[320px] "} src={"/images/hot/top-earn-bg.png"} alt={"top-earn-bg.png"}></Image>
        <div className={"absolute flex flex-col inset-0 py-1 px-3"}>
          <div className={"flex items-center justify-between"}>
            <div onClick={()=>{
              gaTracker.trackEvent("home_pop_title");
              router.push(`/hotsale/${hotSaleId}?utm_source=homepage`);
            }} className={" cursor-pointer text-[#1E2E47] text-base font-bold"}>{hotSaleInfo?.sectionName ?? ''}</div>
            <div onClick={()=>{
              gaTracker.trackEvent("home_pop_title");
              router.push(`/hotsale/${hotSaleId}?utm_source=homepage`);
            }} className={"cursor-pointer text-[#FA791E] text-sm font-bold"}>{t("home.hot.wrap.more")}</div>
          </div>
          <div className={"mt-4 flex-1 flex flex-col gap-5 overflow-y-scroll"}>
            {
              productList.slice(0, 3).map((item, index)=>{
                return  <div onClick={()=>{
                  gaTracker.trackEvent("home_pop_product");
                  const query = hotSaleId ? `?saleId=${hotSaleId}` : "";
                  router.push(`/product/${item.productId}${query}`);
                }} key={index} className={"flex items-center cursor-pointer h-[72px] bg-white rounded-xl px-2 justify-between"}>
                  {
                    index < 3 ? <Image className={"w-[20px] h-[20px]"} src={`/images/hot/hot${index + 1}.png`} alt={"hot"} width={20} height={20}></Image> : <div className={"w-[20px] h-[20px]"}></div>
                  }
                  <AppImage className={"!w-[66px] !h-[66px] rounded-lg ml-2"} src={getProductImageV2(item)} alt={"top"}></AppImage>
                  <div className={"text-xs text-[#1E2E47CC] ml-2"}>
                    <div className={"px-2"}>{t('hot_sale_h5.earn_per_sale')} <span className={"text-base font-bold text-[#1E2E47]"}>{item?.showEarnPer}</span> <span className={"line-through text-sm text-[#C9CACC]"}>{item?.showOpenEarnPer}</span></div>
                    <div className={"bg-[#FFF9F5] px-2 rounded mt-1 border border-[#FAC29B] text-[#7D8FAD]"}>{t('hot_sale_h5.earn_per_sale')} <span className={"text-sm text-[#FA791E] font-bold"}>{item?.showCapEarnPer}</span> <span>{t("common.more")}</span></div>
                  </div>
                  <div className={"ml-2 text-center"}>
                    <div className={"text-sm text-[#1E2E47]"}>{item.day7SoldNum}</div>
                    <div className={"text-xs text-[#7D8FAD]"}>{t("7D.sold")}</div>
                  </div>
                </div>;
              })
            }
          </div>
          <div className={"h-5"}></div>
        </div>
      </div> : null
    }
  </div>;


  // return  <>
  // {
  //   productList && productList?.length > 0  ? <>
  //     <div className={"w-full relative h-[270px] p-[1px] bg-gradient-to-r from-[#FFF5D8]  to-[#F3EDE7] rounded-[16px]"}>
  //       <div onClick={scrollLeft} className={"absolute left-[-23px] cursor-pointer tap flex items-center justify-center bg-[#F6F5F4] top-[112px] w-[46px] h-[46px] rounded-full"}>
  //         <AppImage className={"!w-[30px]"} src={"/images/hot/left-arrow.png"}></AppImage>
  //       </div>
  //       <div className={"bg-white h-full w-full rounded-[16px]"}>
  //         <div className={"w-full p-[20px] flex flex-col h-full bg-gradient-to-r from-[#FFF7E9] via-[#FFFFFF]  to-[#FFFFFF] rounded-[16px]"}>
  //           <div className={"flex items-center justify-between"}>
  //             <div onClick={()=>{
  //               gaTracker.trackEvent("home_pop_title");
  //               router.push(`/hotsale/${hotSaleId}?utm_source=homepage`);
  //             }} className={"cursor-pointer flex items-center gap-[10px]"}>
  //               <AppImage className={"!w-[24px]"} src={"/images/hot-icon.png"}></AppImage>
  //               <div className={"text-[1rem] font-bold"}>{hotSaleInfo?.sectionName ?? ''}</div>
  //             </div>
  //             <div onClick={()=>{
  //               gaTracker.trackEvent("home_pop_more");
  //               router.push(`/hotsale/${hotSaleId}?utm_source=homepage`);
  //             }} className={"flex items-center cursor-pointer"}>
  //               <div className={"text-[#F19B55] font-bold"}>{t("home.hot.wrap.more")}</div>
  //               <AppImage className={"!w-[20px] !object-cover"} src={"/images/hot-more-icon.png"}></AppImage>
  //             </div>
  //           </div>
  //           <div ref={scrollRef} className={"flex items-center gap-[15px] overflow-x-auto hide-scrollbar flex-1 h-full mt-[15px]"}>
  //             {
  //               productList.map(item =>{
  //                 return <div onClick={()=>{
  //                   gaTracker.trackEvent("home_pop_product");
  //                   const query = hotSaleId ? `?saleId=${hotSaleId}` : "";
  //                   router.push(`/product/${item.productId}${query}`);
  //                 }} key={item.productId}>
  //                   <HotProductItem src={item?.alyImage ? item.alyImage : item.image} price={ userInfo?.obtain ?  item.showCapEarnPer : item.showEarnPer}></HotProductItem>
  //                 </div>;
  //               })
  //             }
  //           </div>
  //         </div>
  //       </div>
  //       <div onClick={scrollRight} className={"absolute right-[-23px] cursor-pointer tap flex items-center justify-center bg-[#F6F5F4] top-[112px] w-[46px] h-[46px] rounded-full"}>
  //         <AppImage className={"!w-[30px]"} src={"/images/hot/right-arrow.png"}></AppImage>
  //       </div>
  //     </div>
  //     <div className={"mt-[50px]"}></div>
  //   </> : null
  // }
  // </>;
};

const HotProductItem = ({ src, price }) => {
  const {t} = useLanguage();
  return (
    <div className={"cursor-pointer flex border-[#F4F6FE] h-full border rounded-[16px] pt-[15px] flex-col h-[178px] items-center bg-[#FFFFFF] w-[185px]"}>
      <AppImage className={"!w-[100px] border-[#EDF0FE] border-[2px] !h-[100px] object-cover rounded-lg"} src={src} />
      <div className={"text-[20px] text-[#F0774A] font-bold mt-[10px]"}>{price ?? "--"}</div>
      <div className={"text-[12px] text-[#6E7281] mt-[3px] mb-2"}>{t("home.filter.earn_per_sale")}</div>
    </div>
  );
};

export default  HotProductWrap;
